import React, { useState } from "react";
import { NewRouteContext } from "./context";

const initialValue = {
  start: {},
  end: {},
  steps: [],
};

const NewRouteProvider = ({ children }) => {
  const [newRoute, setNewRoute] = useState(initialValue);
  const [refreshed, setRefreshed] = useState(false);

  const handleNewRouteUpdate = (category, item) => {
    switch (category) {
      case "start":
      case "end":
        setNewRoute(item);
        // tempNewRoute[category] = item;
        break;
      default:
        const tempRoute = newRoute ?? initialValue;
        const stepsNames = [];
        for (let step of tempRoute?.steps) {
          stepsNames.push(step.title);
        }
        if (!stepsNames.includes(item.title)) {
          tempRoute.steps.push({ ...item, orderId: tempRoute.steps.length });
        }

        setNewRoute(tempRoute);
        break;
    }
    setRefreshed(!refreshed);
  };

  const removeStep = (step) => {
    const tempRoute = newRoute;

    tempRoute.steps = tempRoute.steps.filter(
      (stepItem) => stepItem.title !== step.title
    );
    setNewRoute(tempRoute);
    setRefreshed(!refreshed);
  };

  const updateStepOrder = (steps) => {
    const tempRoute = newRoute;
    tempRoute.steps = steps;

    setNewRoute(tempRoute);
    setRefreshed(!refreshed);
  };

  const clearRoute = () => {
    setNewRoute(initialValue);
  };

  return (
    <NewRouteContext.Provider
      value={{
        get: newRoute,
        set: handleNewRouteUpdate,
        removeStep,
        updateStepOrder,
        clearRoute,
        refreshed,
      }}
    >
      {children}
    </NewRouteContext.Provider>
  );
};

export default NewRouteProvider;
